import { render } from "./Tables.vue?vue&type=template&id=af77068c&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=af77068c&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/LEADA/mi-stock-leada-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af77068c"]])

export default __exports__